import React from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField } from '@the-platform-group/component-library'
import { Select } from '@the-platform-group/component-library/Select'

import { AGENTIC_PROMPT_CATEGORIES, AGENTIC_PROMPT_STATUSES } from 'constants/agenticPrompts'

const categoryOptions = AGENTIC_PROMPT_CATEGORIES.map(category => ({
  value: category,
  label: category,
}))

const statusOptions = AGENTIC_PROMPT_STATUSES.map(status => ({
  value: status,
  label: status,
}))

const filterInputHeight = { '& .MuiOutlinedInput-root': { height: 40 } }

const PromptFilters = ({ filters, onSearch, onCategoriesChange, onStatusesChange }) => (
  <Grid container spacing={2} alignItems="center">
    <Grid item md={4} xs={12}>
      <TextField
        fullWidth
        placeholder="Search by title or body"
        defaultValue={filters.term ?? ''}
        onChange={onSearch}
        sx={filterInputHeight}
      />
    </Grid>
    <Grid item md={4} xs={12}>
      <Select
        fullWidth
        isMulti
        margin="none"
        options={categoryOptions}
        value={filters.categories || []}
        onChange={event => onCategoriesChange(event.target.value)}
        placeholder="Filter by category"
        sx={filterInputHeight}
      />
    </Grid>
    <Grid item md={4} xs={12}>
      <Select
        fullWidth
        isMulti
        margin="none"
        options={statusOptions}
        value={filters.statuses || []}
        onChange={event => onStatusesChange(event.target.value)}
        placeholder="Filter by status"
        sx={filterInputHeight}
      />
    </Grid>
  </Grid>
)

PromptFilters.propTypes = {
  filters: PropTypes.shape({
    term: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    statuses: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
  onCategoriesChange: PropTypes.func.isRequired,
  onStatusesChange: PropTypes.func.isRequired,
}

export default PromptFilters
